import { CamaraFotosProvider } from '@/components/fotos/CamaraFotos';
import { Toaster } from '@/components/ui/sonner';
import { router } from '@/router/routes';
import { RouterProvider } from 'react-router-dom';

/**
 * App raíz de ObrasControl.
 *
 * El gate de auth (login vs app autenticada) vive dentro del router como
 * un layout protegido — ver `router/routes.tsx`. App.tsx solo monta el
 * router y los providers globales (Toaster).
 *
 * Diferencia con el template oficial: no usamos MsalProvider porque el
 * personal de campo no tiene cuenta de Entra ID (auth por PIN propio).
 */
export function App() {
  return (
    <>
      {/* Cámara de fotos de obra: se abre desde cualquier pantalla (useCamaraFotos). */}
      <CamaraFotosProvider>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </CamaraFotosProvider>
      {/* Arriba: abajo tapaba la barra de navegación y los botones de cámara. */}
      <Toaster position="top-center" />
    </>
  );
}
